import React, { useEffect, useState } from "react";
import SelectField from "../components/MySelect";
import { useGetPickupQuery } from "../store/api/recipientApi";
import { useSetPickupPointMutation } from "../store/api/buyForMeApi";
import Button from "../components/Button";

const ChoosePVZ = () => {
  const [form, setForm] = useState({
    selectedPickup: 0,
  });

  const [setPickupPoint] = useSetPickupPointMutation();

  const { data: pickup = { pickup_list: [] }, refetch } = useGetPickupQuery();

  useEffect(() => {
    if (Array.isArray(pickup.prefer_pickup) && pickup.prefer_pickup.length)
      setForm({
        selectedPickup: pickup.prefer_pickup[0].prefer_pickup,
      });
  }, [pickup]);
  return (
    <div className="personal-info-form">
      <SelectField
        label="Предпочитаемый пункт выдачи"
        value={form.selectedPickup}
        onChange={(e) => {
          setForm({
            ...form,
            selectedPickup: e.target.value,
          });
        }}
        placeholder="Выберите пункт"
        options={pickup?.pickup_list ?? []}
      />
      {
        pickup.prefer_pickup[0].prefer_pickup != form.selectedPickup ?
          <Button onClick={async () => {
            const { data } = await setPickupPoint({
              pickup: form.selectedPickup,
            });
            alert(data?.message)
            refetch()
          }}>Сохранить</Button> : ""
      }
    </div>
  );
};

export default ChoosePVZ;
